import VueGallery from 'vue-gallery';

export default {
  data() {
    return {
      index: null,
    };
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    gallery: VueGallery,
  },
  methods: {
    openImage(imageIndex) {
      this.index = imageIndex;
    },
    removeLinkTag(a, url) {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    downloadImage(url) {
      if (url) {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const filename = url.split('/').pop();
            if (window.navigator.msSaveBlob) {
              // IE doesn't support download tag
              window.navigator.msSaveBlob(blob, filename);
            } else {
              const a = document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              setTimeout(this.removeLinkTag(a, url), 100);
            }
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/file-gallery/FileGallery.js